import type { SandboxStatus } from "schemas/generated/agentConnection";

const SANDBOX_STATUS_DISPLAY_TEXT: Record<SandboxStatus, string | null> = {
  startingSandbox: "Setting up environment",
  waitingForSupervisor: "Starting environment",
  initializingWorkspace: "Setting up workspace",
  startingServices: "Starting agent",
  sendingMessage: "Sending message",
  streaming: null,
};

export function getSandboxStatusDisplayText(
  status: SandboxStatus,
): string | null {
  return SANDBOX_STATUS_DISPLAY_TEXT[status];
}
